export default __webpack_public_path__ + "static/media/icon-audio.3d6c6d64.svg";